<template>
  <div class="wrapBox">
    <div class="newbox">
      <div class="newbox_left">
        <div class="detail-box-header">
          <div class="breadcrumb">
            <span style="cursor: pointer;" @click="$router.push('/IndexPage')">首页</span> >
            <span>新闻动态</span>
          </div>
          <h1 class="detail-box-header-title">{{newsContent.title}}</h1>
          <p class="time">{{newsContent.creationTime}}</p>
        </div>
        <div class="detail-content" v-html="newsContent.valus"></div>
        <div class="nextpage">
          <p
            v-if="currIndex-1>=0"
            @click="preAricle(newsList[currIndex-1]['messagesTextId'])"
          >上一篇：{{newsList[currIndex-1]['title']}}</p>
          <p
            v-if="currIndex+1<7"
            @click="nextAricle(newsList[currIndex+1]['messagesTextId'])"
          >下一篇：{{newsList[currIndex+1]['title']}}</p>
        </div>
      </div>
      <div class="newbox_right">
        <div class="head-img">
          <img src="@/assets/images/top-news-img.jpg" alt />
        </div>
        <div class="right_content">
          <p class="right_content-title">
            <img style="vertical-align: middle;" width="9%" src="@/assets/images/start.png" /> 精选新闻
          </p>
          <ul>
            <li
              v-for="item in newsList"
              :key="item.messagesTextId"
              @click="toNewsDetail(item.messagesTextId)"
            >
              <div>
                <p class="cot">{{item.title}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      newsContent: "",
      newsList: [],
      currIndex: null,
    };
  },
  mounted() {
    let id = this.$route.query.id;
    this.getNewsDetail(id);
    this.getNews();
  },
  methods: {
    //获取新闻内容
    getNewsDetail(id) {
      this.$post("publicMessage/get/" + id + ".action", {}, "externalURL").then(
        (data) => {
          this.newsContent = data;
          let reg = new RegExp(
            "/cloud-wlxy//skin/color7/js/UEditor/dialogs/attachment/fileTypeImages/",
            "g"
          );
          this.newsContent.valus = this.newsContent.valus.replace(
            reg,
            "http://www.cdssxy.com/cloud-wlxy//skin/color7/js/UEditor/dialogs/attachment/fileTypeImages/"
          );
        }
      );
    },
    //获取最新新闻
    getNews() {
      let parmas = {
        page: 1,
        limit: 7,
      };
      this.$post("publicMessage/list.action", parmas, "externalURL").then(
        (data) => {
          this.newsList = data;
          let id = this.$route.query.id;
          this.newsList.forEach((item, index) => {
            if (item.messagesTextId == id) {
              this.currIndex = index;
            }
          });
        }
      );
    },
    //点击上一篇下一篇
    preAricle(id) {
      this.getNewsDetail(id);
      this.currIndex = this.currIndex - 1;
    },
    nextAricle(id) {
      this.getNewsDetail(id);
      this.currIndex = this.currIndex + 1;
    },
    toNewsDetail(id) {
      this.getNewsDetail(id);
      this.newsList.forEach((item, index) => {
        if (item.messagesTextId == id) {
          this.currIndex = index;
        }
      });
    },
  },
};
</script>
<style scoped>
.wrapBox {
  padding-top: 30px;
  background: #f8f8f8;
  padding-bottom: 50px;
}
.newbox {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  text-align: left;
}
.newbox .newbox_left {
  width: 75%;
  background: white;
  position: relative;
}
.newbox .newbox_right {
  width: 23%;
}
.breadcrumb {
  color: #494949;
}
.detail-box-header {
  padding: 10px;
  border-bottom: 1px dashed #ccc;
}
.detail-box-header-title {
  padding: 25px 10px 10px;
  font-size: 30px;
  font-weight: normal;
}
.detail-content {
  padding: 20px 10px 50px;
}
.detail-content > p > img {
  width: 10%;
}
.head-img {
  padding: 0 10px;
  height: 170px;
}
.head-img > img {
  width: 100%;
}
.right_content {
  margin: 0 10px;
  min-height: 200px;
  background: white;
  padding: 20px 10px;
}

.right_content > ul {
  list-style: none;
  font-size: 16px;
  padding-left: 25px;
}
.right_content > ul li {
  position: relative;
  margin-bottom: 5px;
  font-size: 16px;
  cursor: pointer;
}
.right_content > ul li:before {
  position: absolute;
  left: -22px;
  top: 9px;
  display: block;
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #a8a8a8;
}
.right_content > ul li .cot {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #494949;
  -o-text-overflow: ellipsis;
  -icab-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.right_content-title {
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #c1c1c1;
  margin: 0;
  margin-bottom: 10px;
}
.nextpage {
  position: absolute;
  bottom: 0;
  left: 15px;
}
.nextpage p {
  cursor: pointer;
}
.nextpage p:hover {
  color: #228ddd;
}
</style>